/** GraphQL query to get chosen bags count. */

export default `
  query getChosenBagsCount($cart_id: String!) {
    xmasGetChosenBagsCount(cart_id: $cart_id)
  }
`;
